<template>
  <a-table
    rowKey="index"
    :dataSource="list"
    size="small"
    :columns="columns"
    :pagination="tablePagination"
    class="mb20"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'deal'">
        <a-button
          size="small"
          type="link"
          @click="() => updateRootModal(record)"
          >菜单权限</a-button
        >
        <a-button
          size="small"
          type="link"
          @click="() => updateRoleNameModal(record)"
          >修改名称</a-button
        >
        <a-button size="small" type="link" @click="() => deleteRole(record)"
          >删除</a-button
        >
      </template>
    </template>
  </a-table>
  <UpdateRoleName />
  <UpdateRoot :role-id="roleId" />
</template>
<script>
import { dateFormat } from 'cupshe-utils'
import { message } from 'ant-design-vue'
import { toRefs, reactive, provide, inject } from 'vue'
import { roles } from 'server/modules/ssoApi.js'
import UpdateRoleName from './UpdateRoleName'
import UpdateRoot from './UpdateRoot'
import { role_operate_post } from 'server/modules/351.js'

export default {
  components: {
    UpdateRoleName,
    UpdateRoot
  },
  setup() {
    const state = inject('state')
    const updateModal = reactive({
      updateVisible: false,
      confirmLoading: false,
      row: {},
      formState: {
        name: ''
      },
      handleOk: () => {
        updateModal.confirmLoading = true
        const { id, name, menuSystemId } = updateModal.formState
        const params = {
          id,
          name,
          menuSystemId
        }
        role_operate_post(params).then(res => {
          if (res.success) {
            setTimeout(() => {
              updateModal.updateVisible = false
              updateModal.confirmLoading = false
            })
            state.initData()
          } else {
            message.error(res.retInfo)
            updateModal.confirmLoading = false
          }
        })
      },
      handleCancel: () => {
        updateModal.updateVisible = false
      }
    })
    const detailState = reactive({
      // 模拟v-model radio
      changeChecks: (e, name) => {
        detailState[name] = [...e]
      },
      // 查询角色权限
      getRoles: async (params, title) => {
        const { setAttrs, systemId } = state
        if (systemId === -1) {
          message.warning('请选择一个系统！')
          return
        }
        const { userId } = params
        const { success, data } = await roles({ userId, systemId })
        if (success) {
          const { list } = data
          setAttrs('userId', userId)
          setAttrs('roles', list)
          setAttrs('title', title)
          setAttrs('visible', true)
        }
      },

      updateRoleNameModal: row => {
        updateModal.updateVisible = true
        updateModal.formState = JSON.parse(JSON.stringify(row))
      }
    })

    const roleSetting = reactive({
      menuVisible: false,
      roleId: '',
      systemId: '',
      handleCancel() {
        roleSetting.menuVisible = false
      },
      handleOk() {
        roleSetting.menuVisible = false
      }
    })

    const updateRootModal = text => {
      state
        .getMenuList(text.id)
        .then(res => {
          if (res.success) {
            roleSetting.roleId = text.id
            roleSetting.systemId = text.menuSystemId
            state.menuList = [res.data]
            let emp = state.deepPermission(state.menuList)
            state.permissionIds = emp
            roleSetting.menuVisible = true
          } else {
            message.error(res.retInfo)
          }
        })
        .catch(() => {})
    }

    provide('detailState', detailState)
    provide('updateModal', updateModal)
    provide('roleSetting', roleSetting)

    return {
      dateFormat,
      ...toRefs(detailState),
      ...toRefs(state),
      updateRootModal,
      columns: [
        {
          title: '角色',
          dataIndex: 'name',
          key: 'name',
          width: 200
        },
        {
          title: '系统',
          dataIndex: 'menuSystemStr',
          key: 'menuSystemStr',
          width: 200
        },
        {
          title: '创建时间',
          key: 'addTime',
          width: 200,
          dataIndex: 'addTime'
        },
        {
          title: '创建者',
          dataIndex: 'creatorStr',
          key: 'creatorStr',
          width: 150
        },
        {
          title: '操作',
          key: 'deal',
          width: 300
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped></style>
